import { contained } from 'ramda-adjunct';
import { ModalName } from '../constants/ModalName';
import { memoize } from './memoize';

export const shouldKeepKeyBehaviorForModal = memoize(
  contained([
    ModalName.ShutterstockDisabled,
    ModalName.CancelAllUploads,
    ModalName.EditBoard,
    ModalName.DeleteBoard,
    ModalName.PermanentDelete,
  ]),
);
